/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BrandsResponseFromJSON, EmailMetricsResponseFromJSON, LiveResponseFromJSON, SnapshotResponseFromJSON } from '../models/index';
import * as runtime from '../runtime';
/**
 *
 */
export class VigilApi extends runtime.BaseAPI {
    /**
     * Return the latest per-brand health snapshot.  Reads ``brand_health/latest``. An absent document is an honest empty list, never a 500 (see ``fetch_latest_brand_health`` for the warning log) — the Firestore writer producing this document may not exist yet in this environment.  Args:     _admin: Admin user info (viewer or admin role, unused — gate only).     db: Firestore client.  Returns:     BrandsResponse: latest brand health entries plus the fetch time.
     * Get Brands
     */
    async getBrandsV1VigilBrandsGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/vigil/brands`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => BrandsResponseFromJSON(jsonValue));
    }
    /**
     * Return the latest per-brand health snapshot.  Reads ``brand_health/latest``. An absent document is an honest empty list, never a 500 (see ``fetch_latest_brand_health`` for the warning log) — the Firestore writer producing this document may not exist yet in this environment.  Args:     _admin: Admin user info (viewer or admin role, unused — gate only).     db: Firestore client.  Returns:     BrandsResponse: latest brand health entries plus the fetch time.
     * Get Brands
     */
    async getBrandsV1VigilBrandsGet(initOverrides) {
        const response = await this.getBrandsV1VigilBrandsGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * Return the honest pending-deploy placeholder for email metrics.  Zero mock data: ``email_service`` has no deployed metrics collection to read from, so this always returns ``status=\"pending_deploy\"`` with ``data=None`` rather than fabricating numbers.  Args:     _admin: Admin user info (viewer or admin role, unused — gate only).  Returns:     EmailMetricsResponse: pending-deploy status placeholder.
     * Get Email
     */
    async getEmailV1VigilEmailGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/vigil/email`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => EmailMetricsResponseFromJSON(jsonValue));
    }
    /**
     * Return the honest pending-deploy placeholder for email metrics.  Zero mock data: ``email_service`` has no deployed metrics collection to read from, so this always returns ``status=\"pending_deploy\"`` with ``data=None`` rather than fabricating numbers.  Args:     _admin: Admin user info (viewer or admin role, unused — gate only).  Returns:     EmailMetricsResponse: pending-deploy status placeholder.
     * Get Email
     */
    async getEmailV1VigilEmailGet(initOverrides) {
        const response = await this.getEmailV1VigilEmailGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * Return current-hour and trailing-24h live traffic metrics.  Built from ``daily_metrics/{today}`` and ``/{yesterday}`` — see ``build_live_metrics`` for the two-document stitching logic. ``plausible_realtime_visitors``/``country_live`` are honestly zero/empty today (no Plausible Stats-API query client wired in this backend).  Args:     _admin: Admin user info (viewer or admin role, unused — gate only).     db: Firestore client.  Returns:     LiveResponse: live metrics plus the time this API served them.
     * Get Live
     */
    async getLiveV1VigilLiveGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/vigil/live`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => LiveResponseFromJSON(jsonValue));
    }
    /**
     * Return current-hour and trailing-24h live traffic metrics.  Built from ``daily_metrics/{today}`` and ``/{yesterday}`` — see ``build_live_metrics`` for the two-document stitching logic. ``plausible_realtime_visitors``/``country_live`` are honestly zero/empty today (no Plausible Stats-API query client wired in this backend).  Args:     _admin: Admin user info (viewer or admin role, unused — gate only).     db: Firestore client.  Returns:     LiveResponse: live metrics plus the time this API served them.
     * Get Live
     */
    async getLiveV1VigilLiveGet(initOverrides) {
        const response = await this.getLiveV1VigilLiveGetRaw(initOverrides);
        return await response.value();
    }
    /**
     * Return the latest pair-watch decision snapshot.  Reads ``vigil_snapshots/latest``, written hourly by the ``metric_pair_watch`` job. An absent document is an honest empty list, never a 500 (see ``fetch_latest_snapshots`` for the warning log).  Args:     _admin: Admin user info (viewer or admin role, unused — gate only).     db: Firestore client.  Returns:     SnapshotResponse: latest snapshots plus the time this API served them.
     * Get Snapshot
     */
    async getSnapshotV1VigilSnapshotGetRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HTTPBearer", []);
            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        let urlPath = `/v1/vigil/snapshot`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => SnapshotResponseFromJSON(jsonValue));
    }
    /**
     * Return the latest pair-watch decision snapshot.  Reads ``vigil_snapshots/latest``, written hourly by the ``metric_pair_watch`` job. An absent document is an honest empty list, never a 500 (see ``fetch_latest_snapshots`` for the warning log).  Args:     _admin: Admin user info (viewer or admin role, unused — gate only).     db: Firestore client.  Returns:     SnapshotResponse: latest snapshots plus the time this API served them.
     * Get Snapshot
     */
    async getSnapshotV1VigilSnapshotGet(initOverrides) {
        const response = await this.getSnapshotV1VigilSnapshotGetRaw(initOverrides);
        return await response.value();
    }
}
